import React, { useEffect, useState } from "react";
import {
	Container,
  Alert,
	Form,
	Card,
	Button,
} from "react-bootstrap";
import { Auth } from "aws-amplify";
import axios from "axios";

import { USER_TYPE } from '../../utils/constants.js'

const CreateAccount = () => {
  const [userType, setUserType] = useState(USER_TYPE.BAKERY);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess("");
        setUsername("");
        setPassword("");
      }, 3000)
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError("");
      }, 7000)
    }
  }, [error]);

  const handleSubmit = async (e) => {
			e.preventDefault();
			const formattedUsername = username.toLowerCase(); // Convert email to lowercase

      try {
        await Auth.signUp({
          username: formattedUsername,
          password,
          attributes: {
            email: formattedUsername,
          },
        });
        await axios.post(
          "https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/assign-group",
          { username: formattedUsername, userType },
        );
        setSuccess(
          "Account created successfully! A verification code has been sent to the account's email.",
        );
        setError("");
      } catch (error) {
        console.error("error: ", error);
        setError(error.message || "An error occurred during user creation.");
      }
		}

  return (
		<Container
			className="d-flex justify-content-center"
			style={{ height: "90vh" }}>
			<Card
				style={{
					maxWidth: "400px",
					width: "100%",
					height: "100%",
					borderRadius: "10px",
				}}
				className="shadow-sm p-4">
				{success && <Alert variant="success">"{success}"</Alert>}
				{error && <Alert variant="danger">{error}</Alert>}
				<h3 className="text-center mb-4">Create Account</h3>
				<Form.Group className="mt-3 mb-5">
					<Form.Label>Select User Type:</Form.Label>
					<Form.Select
						value={userType}
						onChange={(e) => setUserType(e.target.value)}>
						{[USER_TYPE.BAKERY, USER_TYPE.CUSTOMER].map((type) => (
							<option key={type} value={type}>
								{type}
							</option>
						))}
					</Form.Select>
				</Form.Group>

				<Form onSubmit={handleSubmit}>
					<Form.Group className="mb-3">
						<Form.Label>Email Address</Form.Label>
						<Form.Control
							type="text"
							placeholder="Enter account's email address"
							value={username}
							onChange={(e) => setUsername(e.target.value.toLowerCase())} // Convert as user types
							required
						/>
					</Form.Group>

					<Form.Group className="mb-3">
						<Form.Label>Password</Form.Label>
						<Form.Control
							type="password"
							placeholder="Enter account's password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
					</Form.Group>

					<Button variant="primary" type="submit" className="w-100">
						Submit
					</Button>
				</Form>
			</Card>
		</Container>
	);
}

export default CreateAccount;